/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestTargetResponse } from '../../models/harvest-target-response';

export interface GetZoneTargets$Params {
  facilityId: number;
  date?: string;
  dateTo?: string;
  zoneId?: Array<number>;
}

export function getZoneTargets(http: HttpClient, rootUrl: string, params: GetZoneTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestTargetResponse>>> {
  const rb = new RequestBuilder(rootUrl, getZoneTargets.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.query('date', params.date, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('zoneId', params.zoneId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestTargetResponse>>;
    })
  );
}

getZoneTargets.PATH = '/api/facilitygroup/overview/zones/targets/{facilityId}';
